/* eslint-disable prefer-destructuring */
import React from "react";
import { ApolloProvider } from "@apollo/react-hooks";

import apolloClient from "../../../../shared/utilities/graphql/apolloClient";
import ClaimDealBox from "../ClaimDealBox";

let closingId = "";
let listingTitle = "";
const claimDealBox = document.getElementById("claim-deal-box");

if (claimDealBox) {
  closingId = claimDealBox.dataset.id;
  listingTitle = claimDealBox.dataset.title;
}

const App = () => (
  <ApolloProvider client={apolloClient}>
    <ClaimDealBox closingId={closingId} listingTitle={listingTitle} />
  </ApolloProvider>
);

export default App;
